<span class="nc-animated-shiny-text"
    style="--shiny-width: {{ncShimmerWidth}}px; --text-color: {{ncTextColor}}; --shiny-color: {{ncShinyColor}}; --animation-duration: {{ncDuration}}ms;">
    {{ncText}}
</span>